import { TwcProduct } from '../../../../twc-products';

export const LIFR_FLIGHT_RULES_PRODUCT_DATA: TwcProduct = {
  id: 'lifr',
  defaultProductId: 'flightrules-lifr-boeing',
  productName: 'Weather-Flight-Rules-LIFR-TWC',
  label: 'LIFR',
  weatherType: 'FLT_RULES_LIFR',
  description: 'TWC product (raster, forecast) - Global LIFR Flight Conditions',
  series: 'Forecast',
  timeSlicePeriodInMinutes: 360,
  lodMax: 5,
  protocol: 'WebTile',
  forecastTimeSlicePeriod: 60,
  flightLevelProductIds: {},
  zOrder: 86
};
